import React from 'react';
import { useIntl, defineMessage } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../primitives/Panel';
/* eslint-disable css-modules/no-unused-class */
import styles from './TrendsSummaryPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

const messages = {
  kicker: defineMessage({ id: 'app.sml.aiInsights.kicker', defaultMessage: 'AI daily brief' }),
  error: defineMessage({
    id: 'app.sml.aiInsights.error',
    defaultMessage: 'Couldn’t generate today’s brief right now.',
  }),
  retry: defineMessage({ id: 'app.sml.aiInsights.retry', defaultMessage: 'Retry' }),
};

interface Props {
  onRetry: () => void;
}

const SummaryErrorViewComponent: React.FC<Props> = ({ onRetry }) => {
  const intl = useIntl();
  return (
    <Panel className={styles.panel}>
      <PanelHead title={intl.formatMessage(messages.kicker)} />
      <PanelBody>
        <span className={styles.errorPill}>
          {intl.formatMessage(messages.error)}{' '}
          <button type="button" className={styles.retryButton} onClick={onRetry}>
            {intl.formatMessage(messages.retry)}
          </button>
        </span>
      </PanelBody>
    </Panel>
  );
};

export const SummaryErrorView = TypedMemo(SummaryErrorViewComponent);
